import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RoutesAll, Cookies } from 'src/app/Constants/app.constants';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private authService: AuthenticationService) {
  }

  canActivate() {
      if (this.authService.getCookies(Cookies.userId) && this.authService.getCookies(Cookies.apiToken)) {
        // logged in so return true
        return true;
      }
      // not logged in so redirect to login page with the return url
      this.router.navigate([RoutesAll.authenication]);
      return false;
  }
}